<template>
    <b-modal content-class="modal-dowload" hide-footer ref="modal-modulo" hide-header-close centered>
        <b-container fluid style="padding-top: 2rem;">
            <b-row align-h="center"><img src="@/assets/images/descarga.svg" alt=""></b-row>
            <b-row align-h="center">
                <b-col lg="12" class="mt-4 text-center">
                    <p class="modal-titulo">DESCARGA COMPLETA</p>
                </b-col>
            </b-row>
            <b-row align-h="center">
                <b-col lg="12" class="text-center">
                    <p class="modal-subtitulo ">Tus resultados fueron descargados <br>exitosomente.</p>
                </b-col>
            </b-row>
            <b-row align-h="center" class="mb-2 ml-1">
                <b-col lg="12" class="mt-4 text-center">
                    <button @click="cerrar()" class="modal-button">
                        <span>ACEPTAR</span>
                    </button>
                </b-col>
            </b-row>
        </b-container>
    </b-modal>
</template>
<script>

    export default {
        name: 'ModalDowload',
        mounted() {
            this.$refs['modal-modulo'].show()
        },
        methods: {
            cerrar() {
                this.$store.dispatch('setActiveModal', false)
                this.$refs['modal-modulo'].hide()
            }
        }
    }
</script>
<style scoped>

</style>
